export default "__VITE_ASSET__CcGUwlbh__"